





















































































































































import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import MHeader, { IAction } from "../utility/mmmint/MHeader.vue";
import { ICost } from "@/models/cost.entity";
import { CostGoToHelper } from "@/lib/utility/cost-go-to-helper";
import { handleError } from "@/lib/utility/handleError";
import { PartnerModule } from "@/store/modules/partner";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import RefsSelect from "../utility/RefsSelect.vue";
import { CostModule } from "@/store/modules/cost.store";
import MDetailViewGrid from "../utility/mmmint/MDetailViewGrid.vue";
import { $t } from "@/lib/utility/t";
import { CostGroupModule } from "@/store/modules/cost-group.store";
import RefsCostGroup from "@/components/utility/RefsCostGroup.vue";
import CostCardDocuments from "@/components/cost/CostCardDocuments.vue";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";

@Component({
  components: {
    MHeader,
    MDetailViewGrid,
    ActivityCard: () => import("@/components/thg/ActivityCard.vue"),
    RefsSelect,
    RefsCostGroup,
    CostCardDocuments
  }
})
export default class CostCard extends mixins(PartnerFallbackMixin) {
  @Prop()
  value!: ICost;

  @Prop()
  hideBreadCrumbs!: boolean;

  @Prop()
  showDetailButton!: boolean;

  get createdDate() {
    return simpleDoubleDigitDate(this.value.timestamp.created);
  }

  get breadCrumbs() {
    if (this.hideBreadCrumbs) {
      return undefined;
    }
    const goTo = CostGoToHelper.locations;

    return [
      { text: $t("cost.costTable"), exact: true, to: goTo.costTable({ partnerId: this.value.partnerId }) },
      {
        text: this.value.title,
        exact: true,
        to: goTo.costDetail({ partnerId: this.value.partnerId, costId: this.value.id })
      }
    ];
  }

  get actions(): IAction[] {
    const actions: IAction[] = [];

    if (this.showDetailButton) {
      actions.push({
        text: $t("project.ticket.actions.openInNewTab"),
        key: "detail",
        icon: "mdi-open-in-new",
        color: "",
        exec: () =>
          new CostGoToHelper(this.$router).goToCostDetail({
            partnerId: this.value.partnerId,
            costId: this.value.id,
            newTab: true
          })
      });
    }

    actions.push({
      text: $t("project.ticket.editTitle"),
      key: "title",
      icon: "mdi-pencil",
      color: "",
      exec: this.startEditingTitle
    });

    return actions;
  }

  get groups() {
    return CostGroupModule.entities;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get source() {
    return {
      refId: this.value.id,
      refType: BackendResourceEnum.COST
    };
  }

  get refsCategories(): BackendResourceEnum[] {
    return [BackendResourceEnum.VEHICLE, BackendResourceEnum.REPORT];
  }

  get tags() {
    const tags = new Set<string>();
    CostModule.entities.forEach(t => t.tags?.forEach(tag => tags.add(tag)));

    return Array.from(tags)
      .sort()
      .filter(t => !this.value.tags.includes(t));
  }

  isLoadingTitle = false;

  isLoadingTotal = false;

  isLoadingDescription = false;

  isLoadingRefs = false;

  isLoadingTags = false;

  isLoadingFiles = false;

  isLoadingGroup = false;

  isTotalMenu = false;

  isEditingTitle = false;

  editTitleCopy = this.value.title;

  totalCopy = this.value.total;

  isEditDescription = false;

  descriptionCopy = this.value.description ?? "";

  startEditingTitle() {
    this.editTitleCopy = this.value.title;
    this.isEditingTitle = true;
  }

  cancelEditTitle() {
    this.isEditingTitle = false;
    this.editTitleCopy = this.value.title;
  }

  async saveEditTitle() {
    this.isLoadingTitle = true;
    this.value.title = this.editTitleCopy;
    await this.value
      .updatePartial({
        title: this.editTitleCopy
      })
      .catch(handleError);
    this.isLoadingTitle = false;
    this.isEditingTitle = false;
  }

  startEditDescription() {
    this.descriptionCopy = this.value.description ?? "";
    this.isEditDescription = true;
  }

  abortEditDesciption() {
    this.descriptionCopy = this.value.description ?? "";
    this.isEditDescription = false;
  }

  async saveEditDesciption() {
    this.isLoadingDescription = true;
    await this.value
      .updatePartial({
        description: this.descriptionCopy
      })
      .catch(handleError);
    this.isLoadingDescription = false;
    this.isEditDescription = false;
  }

  async saveRefs() {
    this.isLoadingRefs = true;
    await this.value
      .updatePartial({
        refs: this.value.refs
      })
      .catch(handleError);
    this.isLoadingRefs = false;
  }

  async saveTags() {
    this.isLoadingTags = true;
    await this.value
      .updatePartial({
        tags: Array.from(new Set([...this.value.tags]))
      })
      .catch(handleError);
    this.isLoadingTags = false;
  }

  async saveFiles(files: string[]) {
    this.isLoadingFiles = true;
    await this.value
      .updatePartial({
        files
      })
      .catch(handleError);
    this.isLoadingFiles = false;
  }

  async saveGroup() {
    this.isLoadingGroup = true;
    await this.value
      .updatePartial({
        group: this.value.group
      })
      .catch(handleError);
    this.isLoadingGroup = false;
  }

  async saveTotal() {
    this.isLoadingTotal = true;
    await this.value
      .updatePartial({
        total: Number(this.totalCopy)
      })
      .catch(handleError);
    this.isLoadingTotal = false;
    this.isTotalMenu = false;
  }

  startEditTotal() {
    this.totalCopy = this.value.total ?? 0;
  }

  abortEditTotal() {
    this.totalCopy = this.value.total ?? 0;
    this.isTotalMenu = false;
  }
}
